import {useState} from "react";
import Loading from "../../Loading";
import Money from "./dailyStats/Money";
import Students from "./dailyStats/Students";
import MonthChoice from "../../components/MonthChoice";
import useDB from "../../hooks/useDB";
import Error from "../../components/Error";
export default function Overview(props) {

  const [year, setYear] = useState(new Date().getFullYear())
  const [month, setMonth] = useState(new Date().getMonth())

  const { center } = props;

  const [data, , error, loading] = useDB(`/dailystats/${year}/${month+1}`)

  if (error) return <Error />
  if( loading) return <Loading />

  const { dailyStats, target } = data

  const chartFormat = {
    width: 450,
    height: 400,
    padding: 10,
    margin: 5,
    border: "1px solid #CCCCCC",
    borderRadius: 5,
  };
  if (!dailyStats) return <Loading />;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <MonthChoice
          year={year}
          setYear={setYear}
          month={month}
          setMonth={setMonth}
        />
      </div>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {/*  <ToggleButtonGroup
        value={showCenter}
        exclusive
        onChange={(e) => setShowCenter(e.target.value)}
      >
        <ToggleButton value={"All"}>All</ToggleButton>
        {center.locations.map((location) => (
          <ToggleButton value={location._id} key={location._id}>
            {location.name}
          </ToggleButton>
        ))}
      </ToggleButtonGroup> */}
        <Students
          stats={dailyStats}
          center={center}
          title={"Active Students"}
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/newlost"}
          field="activeStudents"
        />
        <Money
          stats={dailyStats}
          title={"New Students"}
          stat={"newStudents"}
          color="#770091"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/newlost"}
          tab="1"
          target={target ? target.newStudents : 0}
          sites="newStudents"
        />
        <Money
          stats={dailyStats}
          title={"Stopped Students"}
          stat={"stoppedStudentsThisMonth"}
          color="#915a00"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/newlost"}
          tab="2"
          upGood={false}
        />
        <Money
          stats={dailyStats}
          title={"Revenue"}
          stat={"revenue"}
          color="#1e8a3b"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link="/tech/revenue-today"
          level={target ? target.baseRevenue : 0}
          sites="revenue"
          fieldType="money"
        />
        <Money
          stats={dailyStats}
          title={"Payments"}
          stat={"payments"}
          color="#00918a"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/money"}
          fieldType="money"
          sites="payments"
        />
        <Money
          stats={dailyStats}
          title={"Costs (non book)"}
          stat={"nonBooksCosts"}
          color="#910016"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/costs"}
          /* sites="costs" */
          fieldType="money"
          upGood={false}
        />
        <Money
          stats={dailyStats}
          title={"Books cost"}
          stat={"booksCost"}
          color="#910016"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/costs"}
          /* sites="costs" */
          fieldType="money"
          upGood={false}
        />
        <Money
          stats={dailyStats}
          title={"Pending Students"}
          stat={"pendingStudents"}
          color="#b55931"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/newlost"}
          tab="5"
          sites="pendingStudents"
          upGood={false}
        />
        <Money
          stats={dailyStats}
          title={"Owed"}
          stat={"owed"}
          color="#4287f5"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link="/owed/1"
          fieldType="money"
          upGood={false}
        />
        <Money
          stats={dailyStats}
          title={"Potential Payments"}
          stat={"potentialPayments"}
          color="#9042f5"
          chartFormat={chartFormat}
          year={year}
          month={month}
          level={target ? target.baseRevenue : 0}
          fieldType="money"
        />
        <Money
          stats={dailyStats}
          title={"Refunds for absent students"}
          stat={"classRefunds"}
          color="#ee96ff"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link="/absent"
          sites="classRefunds"
          fieldType="money"
          upGood={false}
        />{" "}
        <Money
          stats={dailyStats}
          title={"Potential Students"}
          stat={"totalStudents"}
          color="#1e3a8a"
          chartFormat={chartFormat}
          year={year}
          month={month}
          link={"/manage/newlost"}
          tab="5"
          sites="totalStudents"
        />
      </div>
      {/*   <Costs stats={dailyStats} /> */}
      {/*  <RevenueByDay /> */}
    </div>
  );
}
